import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const END_AB_TEST: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation endAbTest($input: EndAbTestInput!) {
    endAbTest(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
